﻿package com.mgacreative.hotelru.domain.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class Reservation(
    val id: String? = null,
    @SerialName("tenant_id") val tenantId: String,
    @SerialName("guest_id") val guestId: String,
    @SerialName("room_id") val roomId: String?,
    @SerialName("check_in_date") val checkInDate: String,
    @SerialName("check_out_date") val checkOutDate: String,
    val status: String = "CONFIRMED",
    @SerialName("room_type") val roomType: String? = null,
    @SerialName("total_price") val totalPrice: Double,
    @SerialName("special_notes") val specialNotes: String? = null,
    @SerialName("agency_id") val agencyId: String? = null,
    @SerialName("adults_count") val adultsCount: Int = 1,
    @SerialName("children_count") val childrenCount: Int = 0,
    @SerialName("created_at") val createdAt: String? = null,
    // Joined data
    val guests: Guest? = null,
    val rooms: Room? = null
)

